// Couleur d'accent d'un personnage, DÉRIVÉE DE SON NOM.
//
// Remplace la table `CHARACTER_COLORS` de `mockSceneData.ts` : six prénoms codés en dur
// (Nina, Raoul, Anna, Emilie, Luca, Youssef), tous issus d'une SEULE mission. Tout autre
// personnage — c'est-à-dire l'immense majorité — retombait sur un même violet, et deux
// interlocuteurs d'une scène se retrouvaient de la même couleur.
//
// La couleur RÉELLE reste celle du runtime (`missioncharacter.color`) quand elle existe.
// Ceci n'est que le repli, et il doit être STABLE : la même personne doit garder sa teinte
// d'un écran à l'autre et d'une session à l'autre, sinon la couleur cesse d'aider à
// reconnaître qui parle — sa seule raison d'être.

/** Palette d'accents lisibles sur fond dark comme sur fond clair. */
const ACCENTS = [
  '#2D6A4F', '#1E3A5F', '#8B1A4A', '#C75000', '#6B4C9A', '#D4A017',
  '#0F766E', '#9D174D', '#B45309', '#4338CA', '#166534', '#7C2D12',
];

/** Couleur par défaut quand il n'y a pas même un name. */
export const ACCENT_NEUTRE = '#6366F1';

/**
 * Teinte stable pour un name. Déterministe : même name => même couleur, toujours.
 *
 * Le name est normalisé (casse, espaces) pour que « Nina Martin » et « nina martin » ne
 * soient pas deux personnes différentes aux yeux de la palette.
 */
export function characterColor(name?: unknown): string {
  // ⚠️ `String(...)` ET NON `name || ''` : le name vient d'un JSON de scénario, où rien ne
  // garantit une chaîne. Un nombre y faisait tomber l'écran de lecture entier sur un
  // `.trim is not a function` — pour une couleur d'accent.
  const key = String(name ?? '').trim().toLowerCase();
  if (!key) return ACCENT_NEUTRE;
  let h = 0;
  for (let i = 0; i < key.length; i++) {
    h = (h * 31 + key.charCodeAt(i)) >>> 0;
  }
  return ACCENTS[h % ACCENTS.length];
}
